var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPropose4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 80,
    height: 80,
    rx: 34,
    fill: "#292929"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3061_14922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4942 40.4334C17.4805 38.4576 19.5799 37.3254 21.2027 38.1986L21.4204 38.3316L27.5584 42.4664C29.7863 43.9676 28.4225 47.3782 25.8761 47.0665L25.6079 47.0206L23.1715 46.4843C24.4099 49.9105 26.6406 52.8903 29.5792 55.0437C32.5178 57.1971 36.0311 58.4266 39.6712 58.5753C43.3113 58.7241 46.9133 57.7854 50.0178 55.879C53.1223 53.9725 55.5887 51.1847 57.1025 47.8709C57.3627 47.3315 57.8238 46.9153 58.387 46.7114C58.9502 46.5076 59.5709 46.5324 60.1161 46.7804C60.6613 47.0285 61.0877 47.4801 61.3041 48.0386C61.5205 48.5971 61.5097 49.2181 61.274 49.7687C56.7197 59.7848 45.4682 65.3384 34.4872 62.3954C29.6424 61.0974 25.3569 58.2465 22.2876 54.2797C19.2183 50.3128 17.5344 45.4489 17.4942 40.4334ZM19.5639 30.7427C24.1181 20.7266 35.3696 15.1754 46.3507 18.116C51.1953 19.4136 55.4807 22.2641 58.55 26.2305C61.6194 30.197 63.3033 35.0606 63.3436 40.0758C63.3597 42.0538 61.2579 43.1884 59.6375 42.3128L59.4174 42.1799L53.2794 38.0451C51.0516 36.5438 52.4153 33.1333 54.9618 33.445L55.2299 33.4908L57.6663 34.0272C56.428 30.601 54.1973 27.6212 51.2587 25.4678C48.3201 23.3143 44.8067 22.0849 41.1666 21.9361C37.5265 21.7873 33.9246 22.726 30.8201 24.6325C27.7156 26.5389 25.2492 29.3268 23.7354 32.6405C23.6152 32.9212 23.4402 33.175 23.2205 33.3871C23.0009 33.5992 22.7411 33.7653 22.4564 33.8756C22.1717 33.986 21.8679 34.0383 21.5627 34.0295C21.2575 34.0208 20.9571 33.9511 20.6792 33.8247C20.4013 33.6983 20.1514 33.5176 19.9443 33.2933C19.7372 33.0689 19.577 32.8055 19.4731 32.5184C19.3692 32.2313 19.3237 31.9263 19.3393 31.6214C19.3549 31.3165 19.4313 31.0177 19.5639 30.7427Z",
    fill: "url(#paint0_linear_3061_14922)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3061_14922",
    x1: 40.4189,
    y1: 17.5002,
    x2: 40.4189,
    y2: 63.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F42222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59131"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3061_14922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.0083,
    height: 55.0083,
    fill: "white",
    transform: "translate(12.9102 12.7458)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropose4);
export default __webpack_public_path__ + "static/media/propose4.6084f1f49dc07b96c7cff23871aa3423.svg";
export { ForwardRef as ReactComponent };